export const baseDictRu: Record<string, string> = {
  $Native: "Русский",
  $English: "Russian",
  // Ошибки
  "Internal error: [msg]": "Внутренняя ошибка: [msg]",
  "Formula can not be displayed as text":
    "Формулу нельзя отобразить в текстовом виде",
  "Expected '(' after [S]": " Требуется '(' после [S]",
  "Unexpected '[C]'": "Неверный символ '[C]' в позиции [pos]",
  "Expected '[ok]' instead of '[bad]'":
    "Требуется '[ok]' вместо '[bad]' в позиции [pos]",
  "Invalid character '[C]'": "Недопустимый символ '[C]' в позиции [pos]",
  "Russian element character":
    "Недопустимый русский символ '[C]'. Для описания химического элемента должны использоваться только латинские символы.",
  "Non-latin element character":
    "Недопустимый символ '[C]'. Для описания химического элемента должны использоваться только латинские символы.",
  "Unknown element character '[C]'":
    "Недопустимый символ '[C]' описания реагента в позиции [pos]",
  "Expected '[C]'": "Требуется '[C]' в позиции [pos]",
  "Unknown element '[Elem]'": "Ошибочный элемент '[Elem]' в позиции [pos]",
  "Comment is not closed": "Не закрыт комментарий, начатый в позиции [pos]",
  "Abstract coefficient is not closed":
    "Не закрыт абстрактный коэффициент, начатый в позиции [pos]",
  "Abstract element is not closed":
    "Не закрыт абстрактный элемент, начатый в позиции [pos]",
  "Expected node declaration before charge":
    "Неизвестно, к чему нужно применить заряд в позиции [pos]",
  "Invalid charge declaration": "Ошибка в описании заряда в позиции [pos]",
  "It is necessary to close the bracket":
    "Необходимо закрыть скобку, открытую в позиции [pos]",
  "Expected variable name": "Требуется указать имя переменной в позиции [pos]",
  "Undefined variable [name]":
    "Не определена числовая переменная '[name]' в позиции [pos]",
  "Invalid node reference '[ref]'":
    "Неправильная ссылка на узел '[ref]' в позиции [pos]",
  "Invalid label": "Неправильная метка в позиции [pos]",
  "Invalid branch close":
    "Нельзя закрыть ветку в позиции [pos], которая не открыта",
  "Cant close branch before bracket":
    "Нельзя закрыть ветку в позиции [pos], пока не закрыта скобка в позиции [pos0]",
  "Cant close bracket before branch":
    "Нельзя закрыть скобку в позиции [pos], пока не закрыта ветка в позиции [pos0]",
  "Invalid bracket close": "Нет пары для скобки, закрытой в позиции [pos]",
  "It is necessary to close the branch":
    "Необходимо закрыть ветку, открытую в позиции [pos]",
  "Expected [must] instead of [have]":
    "Требуется [must] вместо [have] в позиции [pos]",
  "Invalid middle point": "Не используется промежуточная точка",
  "Cant create ring": "Невозможно создать кольцо",
  "Cant close ring": "Невозможно замкнуть кольцо",
  "Invalid version":
    "Для формулы требуется CharChem версии [need] вместо [cur]",
  "Invalid number [n]": "Неверное числовое значение [n] в позиции [pos]",

  "Periodic Table": "Периодическая система химических элементов",
  "Table legend": "Группы химических элементов",
  Group: "Группа",
  Period: "Период",
  Row: "Ряд",
  "[x]-block": "[x]-блок",
  Lanthanides: "Лантаноиды",
  Actinides: "Актиноиды",
  "Alkali metals": "Щелочные металлы",
  "Alkaline earth metals": "Щёлочноземельные металлы",
  "Transition metals": "Переходные металлы",
  "Post transition metals": "Постпереходные металлы",
  Metalloids: "Полуметаллы",
  "Other nonmetals": "Неметаллы",
  Halogens: "Галогены",
  "Noble gases": "Инертные газы",
  "Unknown props": "Св-ва неизвестны",

  "(s)": "(тв)",
  "(l)": "(ж)",
  "(g)": "(г)",
  "(aq)": "(р-р)",
  H: "Водород",
  He: "Гелий",
  Li: "Литий",
  Be: "Бериллий",
  B: "Бор",
  C: "Углерод",
  N: "Азот",
  O: "Кислород",
  F: "Фтор",
  Ne: "Неон",
  Na: "Натрий",
  Mg: "Магний",
  Al: "Алюминий",
  Si: "Кремний",
  P: "Фосфор",
  S: "Сера",
  Cl: "Хлор",
  Ar: "Аргон",
  K: "Калий",
  Ca: "Кальций",
  Sc: "Скандий",
  Ti: "Титан",
  V: "Ванадий",
  Cr: "Хром",
  Mn: "Марганец",
  Fe: "Железо",
  Co: "Кобальт",
  Ni: "Никель",
  Cu: "Медь",
  Zn: "Цинк",
  Ga: "Галлий",
  Ge: "Германий",
  As: "Мышьяк",
  Se: "Селен",
  Br: "Бром",
  Kr: "Криптон",
  Rb: "Рубидий",
  Sr: "Стронций",
  Y: "Иттрий",
  Zr: "Цирконий",
  Nb: "Ниобий",
  Mo: "Молибден",
  Tc: "Технеций",
  Ru: "Рутений",
  Rh: "Родий",
  Pd: "Палладий",
  Ag: "Серебро",
  Cd: "Кадмий",
  In: "Индий",
  Sn: "Олово",
  Sb: "Сурьма",
  Te: "Теллур",
  I: "Йод",
  Xe: "Ксенон",
  Cs: "Цезий",
  Ba: "Барий",
  La: "Лантан",
  Ce: "Церий",
  Pr: "Празеодим",
  Nd: "Неодим",
  Pm: "Прометий",
  Sm: "Самарий",
  Eu: "Европий",
  Gd: "Гадолиний",
  Tb: "Тербий",
  Dy: "Диспрозий",
  Ho: "Гольмий",
  Er: "Эрбий",
  Tm: "Тулий",
  Yb: "Иттербий",
  Lu: "Лютеций",
  Hf: "Гафний",
  Ta: "Тантал",
  W: "Вольфрам",
  Re: "Рений",
  Os: "Осмий",
  Ir: "Иридий",
  Pt: "Платина",
  Au: "Золото",
  Hg: "Ртуть",
  Tl: "Таллий",
  Pb: "Свинец",
  Bi: "Висмут",
  Po: "Полоний",
  At: "Астат",
  Rn: "Радон",
  Fr: "Франций",
  Ra: "Радий",
  Ac: "Актиний",
  Th: "Торий",
  Pa: "Протактиний",
  U: "Уран",
  Np: "Нептуний",
  Pu: "Плутоний",
  Am: "Америций",
  Cm: "Кюрий",
  Bk: "Берклий",
  Cf: "Калифорний",
  Es: "Эйнштейний",
  Fm: "Фермий",
  Md: "Менделеевий",
  No: "Нобелий",
  Lr: "Лоуренсий",
  Rf: "Резерфордий",
  Db: "Дубний",
  Sg: "Сиборгий",
  Bh: "Борий",
  Hs: "Хассий",
  Mt: "Мейтнерий",
  Ds: "Дармштадтий",
  Rg: "Рентгений",
  Cn: "Коперниций",
  Nh: "Нихоний",
  Fl: "Флеровий",
  Mc: "Московий",
  Lv: "Ливерморий",
  Ts: "Теннессин",
  Og: "Оганесон",
};
